import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { KioskAppointment } from '../../kiosk/kiosk.model';
import { Locale } from '../models/locale.model';

import * as moment from 'moment';

@Component({
  selector: 'appointment-card',
  styles: [require('./appointment-card.component.scss')],
  template: require('./appointment-card.component.html'),
  changeDetection: ChangeDetectionStrategy.OnPush,
  preserveWhitespaces: false,
})
export class AppointmentCardComponent{
  @Input() private startTime: string;
  @Input() public arrived: boolean;
  @Input() public serviceName: string;
  @Input() public accountName: string;
  @Input() public patientName: string;
  @Input() public waitingRoomName: string;
  
  get dateInMoment(): moment.Moment {
    return moment(this.startTime);
  }

  get time(): string {
    return this.dateInMoment.format('HH:mm');
  }

  get meridiem(): string {
    return this.dateInMoment.format('a');
  }
}



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/shared/appointment-card/appointment-card.component.ts